export enum TaxType {
  NONE = 'NONE',
  INCLUDED = 'INCLUDED',
  AS_FEES = 'AS_FEES',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/admin/tax-type.ts